import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {IndexComponent} from "./pages/index/index.component";
import {NovoComponent} from "./pages/novo/novo.component";
import {DetalhesComponent} from "./pages/detalhes/detalhes.component";
import {AutenticacaoGuard} from "../../../core/guards/autenticacao-guard";
import {ConfirmarEmailComponent} from "./pages/confirmar-email/confirmar-email.component";

const routes: Routes = [
  { path: "", component: IndexComponent, canActivate: [AutenticacaoGuard] },
  { path: "novo", component: NovoComponent, canActivate: [AutenticacaoGuard] },
  { path: "detalhes/:id/:show", component: DetalhesComponent, canActivate: [AutenticacaoGuard] },
  { path: "detalhes/:id", component: DetalhesComponent, canActivate: [AutenticacaoGuard] },
  { path: "confirmar-email/:token", component: ConfirmarEmailComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsuarioRoutingModule { }
